import { LayoutMenu, LayoutMasters } from "@/sx-layout/models/index";

export type LayoutAppState = {
  layoutMenu: LayoutMenu;
  layoutMasters: LayoutMasters;
};
